import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the Blockcense
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import { getClasses } from 'wfui-digital-core/es/lib';
import { requestNavigation, requestNavigationWithId } from '../../../../../lib/store/navigation/actions';
import * as selectors from '../../../../../lib/store/navigation/selectors';
import WFModalsContext from 'wfui-digital-core/es/WFModalsContext';
import NavigationBarItem from './NavigationBarItem';
import NavigationContext from './NavigationContext';
import ReportMouseHover from '../hover/ReportMouseHover';
import styles from './NavigationBar.less';
var emptyItem = {
  id: null
};

var handleNavigationButtonClick = function handleNavigationButtonClick(_ref) {
  var activeItem = _ref.activeItem,
      setActiveItem = _ref.setActiveItem,
      pinned = _ref.pinned,
      setPinned = _ref.setPinned,
      dispatch = _ref.dispatch;
  return function (item) {
    return function () {
      if (!item.hasMenu) {
        setActiveItem(emptyItem);
        setPinned(false);

        if (item.id) {
          dispatch(requestNavigationWithId(item.id));
        }
      } else if (item.id === activeItem.id && pinned) {
        setActiveItem(emptyItem);
        setPinned(false);
      } else {
        setActiveItem(item);
        setPinned(true);
      }
    };
  };
};

var handleNavigationButtonEnter = function handleNavigationButtonEnter(_ref2) {
  var globalSearchActive = _ref2.globalSearchActive,
      pinned = _ref2.pinned,
      activeItem = _ref2.activeItem,
      setActiveItem = _ref2.setActiveItem;
  return function (item) {
    return function () {
      if (!globalSearchActive && !pinned && item.id !== activeItem.id) {
        setActiveItem(item.hasMenu ? item : emptyItem);
      }
    };
  };
};

var NavigationBar = function NavigationBar() {
  var navigationBarRef = useRef();

  var _useState = useState(emptyItem),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pinned = _useState4[0],
      setPinned = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      menuRef = _useState6[0],
      setMenuRef = _useState6[1];

  var dispatch = useDispatch();
  var navigationItems = useSelector(selectors.navigationItemsSelector);
  var isChildWindowOpen = useSelector(selectors.isModalOpenSelector);

  var _useContext = useContext(WFModalsContext),
      isModalOpen = _useContext.isModalOpen;

  var globalSearchActive = useSelector(selectors.isGlobalSearchActive);
  var navigationBarItems = navigationItems.get('navigationBarItems'); // Focus on first link when a menu opens

  useEffect(function () {
    if (menuRef) {
      var firstElement = menuRef.querySelector('a');
      firstElement.focus();
      menuRef.scrollTop = 0;
    }
  }, [menuRef]); // Prevent menu from opening after global search closes

  useEffect(function () {
    globalSearchActive && setActiveItem(emptyItem);
  }, [globalSearchActive]);

  var closeMenu = function closeMenu() {
    setActiveItem(emptyItem);
    setPinned(false);
  };

  var navigate = function navigate(item) {
    closeMenu();
    dispatch(requestNavigation(item.toJS()));
  };

  var classNames = getClasses({
    styles: styles,
    classes: ['navigationBar']
  });
  var style = activeItem.fitPage ? {
    position: 'relative'
  } : {};
  var context = {
    navigate: navigate,
    closeMenu: closeMenu,
    targetRef: navigationBarRef.current,
    menuRef: menuRef,
    setMenuRef: setMenuRef,
    onNavigationButtonClick: handleNavigationButtonClick({
      activeItem: activeItem,
      setActiveItem: setActiveItem,
      pinned: pinned,
      setPinned: setPinned,
      dispatch: dispatch
    }),
    onNavigationButtonEnter: handleNavigationButtonEnter({
      globalSearchActive: globalSearchActive,
      pinned: pinned,
      activeItem: activeItem,
      setActiveItem: setActiveItem
    }),
    unpin: closeMenu
  };
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    flex: true,
    className: classNames,
    elementRef: navigationBarRef
  }, /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(ReportMouseHover, {
    menuRef: menuRef,
    render: function render(_ref3) {
      var overNavbar = _ref3.overNavbar,
          overMenu = _ref3.overMenu;
      var showMenu = activeItem.id !== null && (overNavbar || overMenu || pinned) && !isChildWindowOpen && !globalSearchActive && !isModalOpen;
      return /*#__PURE__*/React.createElement(Block, {
        layout: true,
        horizontal: true,
        justifyBetween: true,
        flex: true,
        className: styles.barItems,
        style: style,
        el: "ul"
      }, navigationBarItems && navigationBarItems.map(function (item) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: item.id
        }, /*#__PURE__*/React.createElement(NavigationBarItem, {
          item: item,
          showMenu: showMenu && activeItem.id === item.id,
          highlighted: showMenu && activeItem.id === item.id,
          bevName: item.bevName,
          navigationBarRef: navigationBarRef
        }));
      }));
    }
  })));
};

export default NavigationBar;